/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-unused-expressions */
import { KeyboardEvent, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import * as MUI from "@mui/material";
import * as MUIcons from "@mui/icons-material";

import { bikeStore } from "../../../hooks/store";
import { useAuth } from "../../../hooks/auth";

import { LayoutConsultaBike } from "./LayoutConsultaBike";
import { ResultadoConsultaBike } from "../../../components";

type InputProps = {
  chassiBike: string;
};

export const ConsultaBike: React.FC = () => {
  const { control, handleSubmit } = useForm<InputProps>({
    defaultValues: {
      chassiBike: "",
    },
  });
  const { user } = useAuth();

  const { url } = user!.sistemas.filter((s) => {
    return s.id_sistema === 1 ? s.url : false;
  })[0];

  const {
    consultaBikes,
    resultadoBike,
    mensagemBike,
    limparConsultaBike,
  } = bikeStore((state) => state.bike);

  const { loading } = bikeStore((state) => state.global);

  const pesquisaChassiBike = (data: InputProps) => {
    consultaBikes(url, data.chassiBike);
  };

  const keyBoardClick = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    e.key === "Enter";
  }, []);

  return (
    <LayoutConsultaBike>
      <MUI.Grid
        component="form"
        alignItems="center"
        width={["100%", "100%", "100%", "80%", "60%"]}
        container
        spacing={1}
        onSubmit={handleSubmit(pesquisaChassiBike)}
      >
        <MUI.Grid item xs={12} md={4} sm={4}>
          <Controller
            name="chassiBike"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MUI.TextField
                label="Informe o chassi"
                value={value}
                onChange={onChange}
                onKeyPress={keyBoardClick}
                fullWidth
                size="small"
                disabled={loading}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12} md={3} sm={3}>
          <MUI.Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={loading}
            startIcon={<MUIcons.Search />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Consultar
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>
        <MUI.Grid item xs={12} md={3} sm={3}>
          <MUI.Button
            fullWidth
            variant="outlined"
            color="secondary"
            onClick={limparConsultaBike}
            disabled={loading}
            startIcon={<MUIcons.Clear />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Limpar resultado
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>
      </MUI.Grid>

      <MUI.Stack>
        {resultadoBike || mensagemBike ? (
          <MUI.Typography variant="h6">Resultado da consulta:</MUI.Typography>
        ) : (
          false
        )}

        {!loading ? (
          (resultadoBike &&
            resultadoBike?.map((bike) => (
              <ResultadoConsultaBike
                situacao={bike.NM_SITUACAO}
                marca={bike.MARCA}
                chassi={bike.CHASSI}
                to={`consulta-bike/ficha-bike/${bike.CHASSI}/${bike.MARCA}/${bike.ID_BIKE}`}
              />
            ))) || <MUI.Typography variant="h6">{mensagemBike}</MUI.Typography>
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>
    </LayoutConsultaBike>
  );
};
